export default "__VITE_ASSET__BV7Tg7Jz__"